"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cimpress = void 0;
exports.Cimpress = {
    brand: 'Cimpress',
    contacts: [
        {
            name: '',
            email: '',
            type: '',
        },
    ],
    logo: '',
    applicationMetadata: {
        pom: {
            hiddenColumns: [],
        },
    },
};
